export default __webpack_public_path__ + "static/media/incr_HT.ff270fd1.PNG";